module.exports = __webpack_public_path__ + "static/img/s7.693ef72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s7.png
// module id = kHvW
// module chunks = 0